import { DefaultInputType } from './types';

export const DEFAULT_INPUT_VALUE: DefaultInputType = {
  value: '',
  errorText: '',
};
